"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Companies = void 0;
const companiesGetCompanyDetailsCompaniesCompanyNumberGet_js_1 = require("../funcs/companiesGetCompanyDetailsCompaniesCompanyNumberGet.js");
const companiesGetPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet_js_1 = require("../funcs/companiesGetPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class Companies extends sdks_js_1.ClientSDK {
    /**
     * Get Company Details
     *
     * @remarks
     * Get the details of a company from Companies House.
     */
    async getCompanyDetailsCompaniesCompanyNumberGet(security, companyNumber, options) {
        return (0, fp_js_1.unwrapAsync)((0, companiesGetCompanyDetailsCompaniesCompanyNumberGet_js_1.companiesGetCompanyDetailsCompaniesCompanyNumberGet)(this, security, companyNumber, options));
    }
    /**
     * Get Persons With Significant Control
     *
     * @remarks
     * Get a recursive array of people who have significant control over a company.
     *
     * The people with direct control will appear in the first array, with people with indirect control coming
     * afterwards.
     *
     * Where a company has significant control, the people of that company are looked up and added to an array in the next
     * level.
     *
     * The array is organized by control level, where:
     *
     * - Index 0 contains an array of people with primary control
     * - Index 1 contains an array of people with secondary control
     * - Index 2 contains an array of people with tertiary control
     *
     * And so on.
     *
     * Each array can be empty if there are no people at that control level.
     */
    async getPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet(security, companyNumber, options) {
        return (0, fp_js_1.unwrapAsync)((0, companiesGetPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet_js_1.companiesGetPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet)(this, security, companyNumber, options));
    }
}
exports.Companies = Companies;
//# sourceMappingURL=companies.js.map